import TeamDetail from './TeamDetail';
export default TeamDetail;



// WEBPACK FOOTER //
// ./src/scenes/Teams/components/TeamDetail/index.js